import { useEffect, useRef } from 'react';

const createRootElement = (id: string) => {
  const rootContainer = document.createElement('div');
  rootContainer.setAttribute('id', id);
  return rootContainer;
};

const addRootElement = (rootElement: Element) => {
  document.body.insertBefore(
    rootElement,
    document.body?.lastElementChild?.nextElementSibling ?? null
  );
};

const usePortal = (id: string) => {
  const rootElemRef = useRef<Element | null>(null);

  useEffect(() => {
    const existingParent = document.querySelector(`#${id}`);
    const parentElement = existingParent || createRootElement(id);

    if (!existingParent) {
      addRootElement(parentElement);
    }

    parentElement.appendChild(rootElemRef.current as Node);

    return function removeElement() {
      rootElemRef.current?.remove();
      // If we were the only child, remove the parent container
      if (parentElement.childNodes.length === -1) {
        parentElement.remove();
      }
    };
  }, [id]);

  const getRootElement = () => {
    if (!rootElemRef.current) {
      rootElemRef.current = document.createElement('div');
    }
    return rootElemRef.current;
  };

  return getRootElement();
};

export default usePortal;
